import { Component, OnInit } from '@angular/core';
import { SystemUser } from '../system-user';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../service/user.service';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';
import { FaviconService } from '../favicon.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable, combineLatest } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import * as moment from 'moment';
import { ToastMessageService } from '../toast-message.service';
import { BOOKINGEXPORTOPTIONS } from '../csv-export-config';
import { SimpleBrugesVndBooking } from '../simple-bruges-vnd-booking';

@Component({
  selector: 'app-bookings-bruges',
  templateUrl: './bookings-bruges.component.html',
  styleUrls: ['./bookings-bruges.component.css']
})
export class BookingsBrugesComponent implements OnInit {

  user!: SystemUser;
  bookings!: Observable<SimpleBrugesVndBooking[]>;
  bookingsRaw: SimpleBrugesVndBooking[] = [];
  filteredBookings!: Observable<SimpleBrugesVndBooking[]>;
  pdfUrl!: string;
  downloading!: boolean;
  reportDownloadUrl!: SafeResourceUrl;
  recordNumber = 0;
  first: number = 0;

  selectedYear = 2019;
  searchForm!: FormGroup;
  dateSearchForm!: FormGroup;
  filter!: Observable<string>;
  bookingsView: SimpleBrugesVndBooking[] = [];
  bookingsLoading = false;

  selectedOptions: any[] = [];
  exportOptions = BOOKINGEXPORTOPTIONS;



  constructor(
    private userService: UserService,
    private httpService: HttpService,
    private loginService: LoginService,
    private sanitizer: DomSanitizer,
    private favicon: FaviconService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
  }

  ngOnInit(): void {
    this.user = new SystemUser(this.userService.userName, this.userService.roles!);
    this.bookingsLoading = true;
    this.bookings = this.httpService.getActiveBookingsWithVademecumAndPicture();
    this.searchForm = this.builder.group({
      searchTerm: ""
    });
    this.dateSearchForm = this.builder.group({
      startDate: moment().toDate(),
      endDate: moment().toDate()
    });
    this.filter = this.searchForm.get("searchTerm")!.valueChanges.pipe(startWith(""));
    this.initFilter();

    this.bookings.subscribe(bookings => {
      this.bookingsRaw = bookings;
      this.bookingsView = bookings.slice(0, 49);
      this.recordNumber = bookings.length;
      this.bookingsLoading = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.bookingsLoading = false;
    });
  }

  resetSearch() {
    this.bookingsLoading = true;
    this.bookings = this.httpService.getActiveBookingsWithVademecumAndPicture();
    this.bookings.subscribe(bookings => {
      this.bookingsRaw = bookings;
      this.bookingsView = bookings.slice(0, 49);
      this.recordNumber = bookings.length;
      this.bookingsLoading = false;
      this.bookingsLoading = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.bookingsLoading = false;
    });
  }

  searchBookingsByDates() {
    if (this.dateSearchForm.value.startDate && this.dateSearchForm.value.endDate) {
      let startDateStr = moment(this.dateSearchForm.value.startDate).format("YYYY-MM-DD");
      let endDateStr = moment(this.dateSearchForm.value.endDate).format("YYYY-MM-DD");
      this.bookingsLoading = true;
      this.bookings = this.httpService.getActiveBookingsWithVademecumAndPictureByDates(startDateStr, endDateStr);
      this.bookings.subscribe(bookings => {
        console.log(bookings);
        this.bookingsLoading = false;
        this.bookingsRaw = bookings;
        this.bookingsView = bookings.slice(0, 49);
        this.recordNumber = bookings.length;
      }, error => {
        this.toastService.addError("Error", error.message);
        this.bookingsLoading = false;
      });
    }
  }

  initFilter() {
    this.filteredBookings = combineLatest([this.bookings, this.filter]).pipe(
      map(([bookings, filterString]) => {
        return bookings.filter(booking =>
          (booking.firstName.toLowerCase().indexOf(filterString.toLowerCase()) != -1) ||
          (booking.lastName.toLowerCase().indexOf(filterString.toLowerCase()) != -1)
        );
      }
      ));
  }

  sortByStartDate(isDsc: boolean) {
    let modeNumber = 1;
    if (isDsc == false) {
      modeNumber = -1;
    }
    this.bookings.subscribe(bookings => {
      bookings.sort((a, b) => {
        if (a.startDate.isAfter(b.startDate)) {
          return -1 * modeNumber;
        }
        else {
          return 1 * modeNumber;
        }
      });
      this.bookingsRaw = bookings;
      this.bookingsView = bookings.slice(0, 49);
      this.recordNumber = bookings.length;
    });
  }

  downloadPdf(booking: SimpleBrugesVndBooking) {
    booking.downloadingPdf = true;
    this.httpService.getPdfBlob(booking.id, booking.language.name.toLocaleLowerCase()).subscribe(blob => {
      this.pdfUrl = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = this.pdfUrl;
      link.download = "Vademecum " + booking.lastName + " " + booking.firstName + ".pdf";
      link.click();
      booking.downloadingPdf = false;
    });
  }

  exportBookings() {
    if (this.selectedOptions == null || this.selectedOptions.length == 0) {
      return;
    }
    let headerStr = this.buildCsvHeader();

    let bodyStr = this.buildCsvBody();

    console.log(this.bookingsRaw);
    let csvEncodedUri = encodeURI("data:text/csv;charset=utf-8," + headerStr + bodyStr);
    let link = document.createElement("a");
    link.href = csvEncodedUri;
    link.download = "Test.csv";
    link.click();
  }

  updateView(event: any) {
    console.log(event);
    this.bookingsView = this.bookingsRaw.slice(event.first, event.first + event.rows - 1);
  }

  buildCsvHeader() {
    let headerStr = "";
    for (let i = 0; i < this.selectedOptions.length; i++) {
      if (i == this.selectedOptions.length - 1) {
        headerStr = headerStr + this.selectedOptions[i].name + "\n";
      } else {
        headerStr = headerStr + this.selectedOptions[i].name + ";";
      }
    }
    return headerStr;
  }

  buildCsvBody() {
    let bodyStr = "";
    for (let i = 0; i < this.bookingsRaw.length; i++) {
      for (let j = 0; j < this.selectedOptions.length; j++) {
        let value = this.getCsvValue(i, j);
        if (j == this.selectedOptions.length - 1) {
          bodyStr = bodyStr + value + "\n";
        } else {
          bodyStr = bodyStr + value + ";";
        }
      }
    }
    return bodyStr;
  }

  getCsvValue(i: number, j: number) {
    switch (this.selectedOptions[j].id) {
      case 1:
        return this.bookingsRaw[i].id;
      case 2:
        return this.bookingsRaw[i].firstName;
      case 3:
        return this.bookingsRaw[i].lastName;
      //use studentLanguage for Bruges bookings (not student.language)
      case 4:
        return this.bookingsRaw[i].language.name;
      default: return "";
    }
  }
}